module.exports = __webpack_public_path__ + "4cc601e7dd121ca745b70b565dad9463.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-robin-hood-s.png
// module id = 1971
// module chunks = 0